<script>

    export let value = null
    export let placeholder = null
    export let label = null

    const uid = `textarea-${Math.random().toString(36).slice(2, 9)}`

</script>

<div class="field">
    {#if label}
        <label for={uid} class="label">{ label }</label>
    {/if}
    <div class="control">
        <textarea id={uid} bind:value={value} class="textarea" { placeholder }></textarea>
    </div>
</div>
